import React, { useState, useEffect } from "react";
import AdminSidePanel from "./AdminSidePanel";
import { Link } from "react-router-dom";
import { FaPlusCircle } from "react-icons/fa";
import { useCookies } from "react-cookie";
import axios from "axios";
import propertyPhoto from "../../assets/images/house2.png";


function AdminClientView({ location }) {

  const [cookies, removeCookie] = useCookies(["Authorization"]);

  console.log("location.state in adminclientView page is", location.state)
  const clientData = { ...location.state.details };
  console.log(clientData);


  return (
    <div>

      <main className="admin-panel">
        <div className="row">
          <div className="col-lg-2">
            <AdminSidePanel />
          </div>
          <div className="col-lg-9">
            <div className="admin-sitemap">
              Admin Panel {">"} Site Manager {">"} Clients {">"} Client
            </div>
            <br></br>
            <br></br>
          </div>
        </div>
        <div className="property-info">
          <div className="property-info-text">
            <br></br><br></br>
            <h3>Client Name: {clientData.fname} </h3>
            <br></br><br></br>
            <h4>Client Email: {clientData.email}</h4>
            <br></br><br></br>
            <h4>Client Contact Number: {clientData.contactNo}</h4>
            <br></br><br></br>
            <h4>Client Status: {clientData.status}</h4>
            <br></br><br></br>
            <h4>Client Address: {clientData.address}</h4>
          </div>
        </div>
        <br></br><br></br><br></br><br></br>
      </main>



    </div>
  )
}

export default AdminClientView;